module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO37ValorPlaneadoVSValorReal.3cb62db.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO37ValorPlaneadoVSValorReal.mp4
// module id = 763
// module chunks = 1